<template>
    <div class="wrap">
        <div class="title">
            <div class="title_left">就餐人员管理</div>
        </div>
        <div class="innerBox">
            <div class="filtrate">
                <el-input placeholder="姓名,身份证号,手机号" class="w260 seekIpt mr20" v-model="queryLimit.keyword">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="searchPage"></i>
                </el-input>
            </div>
            <div class="operate clear_a">
                <div class="left mt20">
                    <el-button class="selectHeight mr20" type="primary" @click="openAdd">
                        <i style="margin-right: 5px;font-weight: 700;color: #fff;" class="el-icon-plus"></i>新增
                    </el-button>
                    <el-button class="mr20" @click="delTips">批量删除</el-button>
                </div>
                <div class="right mt20">
                    <el-upload action="" class="mr20" style="display: inline-block"  :show-file-list="false"
                               :http-request="uploadConfig" :on-error="fileUploadError" :before-upload="beforeAvatarUploadImport">
                        <el-button type="primary">导入</el-button>
                    </el-upload>
                    <el-button type="primary" @click="downloadModule">导入模板</el-button>
                    <el-button type="primary" @click="allExport">全部导出</el-button>
                </div>
            </div>
            <el-divider></el-divider>
            <div class="content">
                <div class="tabOffTop120">
                    <!-- v-loading="loading" element-loading-text="数据正在努力加载中"  -->
                    <el-table ref="multipleTable" :data="tableData.records" tooltip-effect="dark" style="width: 100%"
                              @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="55">
                        </el-table-column>
                        <el-table-column  prop="name" label="姓名" min-width="180"  show-overflow-tooltip></el-table-column>
                        <el-table-column prop="idCard" min-width="180" label="身份证号" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="unit" min-width="180"  label="单位">
                        </el-table-column>
                        <el-table-column prop="mobile" min-width="180"  label="手机号" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column label="操作" min-width="180">
                            <template slot-scope="scope">
                                <a href="javascript:;" class="operate-a" @click="openEdit(scope.row)">编辑</a>
                                <a href="javascript:;" class="operate-a" @click="delConfirm(scope.row.id)">删除</a>
                            </template>
                        </el-table-column>

                    </el-table>
                </div>
                <div class="pagination-box">
                    <el-pagination background @size-change="pageSizeChange" @current-change="pageCurrentChange"
                                   :current-page="queryLimit.current" :page-sizes="[10, 20, 30, 40,50]" :page-size="queryLimit.size"
                                   layout="total,prev, pager, next, sizes, jumper" :total="tableData.total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog
                :title="status == 'add'? '新增人员':'编辑人员'"
                :close-on-click-modal="false"
                :visible.sync="addDialog"
                width="30%"
                :before-close="cancel"
        >
            <el-form :model="addForm" :rules="rules" ref="addForm" label-width="120px" class="demo-ruleForm">
                <el-form-item label="用餐人员姓名" prop="name">
                    <el-input v-model="addForm.name"  maxlength="30"  placeholder="请输入姓名, 30字以内"></el-input>
                </el-form-item>
                <el-form-item label="身份证号" prop="idCard">
                    <el-input v-model="addForm.idCard"  maxlength="18" placeholder="请输入身份证号"></el-input>
                </el-form-item>
              
                <el-form-item label="单位" prop="unit">
                    <el-input v-model="addForm.unit"  maxlength="30" placeholder="请输入单位, 30字以内"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="mobile">
                    <el-input v-model="addForm.mobile" maxlength="11" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-checkbox v-model="addForm.visible">是否允许观看后厨视频</el-checkbox>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="addConfirm('addForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import * as api from "api/mealPersonnel";

    export default {
        name: "wlList",
        data() {
            return {
                queryLimit: {
                    current: 1,
                    keyword: "",
                    startYear:"",
                    endYear: "",
                    size: 10
                },
                tableData: [],
                multipleSelection: [],
                addDialog: false,
                addForm: {},
                rules: {
                    name: [
                        {required: true, message: "请输入姓名, 30字以内", trigger: "blur"},
                        {min: 1, max: 30, message: "姓名必填,且在30字以内", trigger: "blur"}
                    ],
                    idCard: [
                        {required: true, message: "请输入身份证号", trigger: "blur"},
                        {min: 18, max: 18, message: "请输入正确的身份证号", trigger: "blur", pattern:/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/}
                    ],
                    unit: [
                        {required: true, message: "请输入单位, 30字以内", trigger: "blur"},
                        {min: 0, max: 30, message: "单位名称在30字以内", trigger: "blur"}
                    ],
                    mobile: [
                        {required: true, message: "请输入手机号", trigger: "blur"},
                        {min:11, max: 11, message: "请输入正确的手机号",pattern:/^[1]([3-9])[0-9]{9}$/, trigger: "blur"}
                    ]
                },
                status:"",
                uploadDialog:false,
                importLoad: false
            };
        },
        methods: {
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            pageCurrentChange(current) {
                this.queryLimit.current = current;
                this.getPageData();
            },
            pageSizeChange(size) {
                this.queryLimit.size = size;
                this.getPageData();
            },
            handleClick() {
                if(this.queryLimit.startYear && this.queryLimit.endYear ||  this.queryLimit.startYear === null && this.queryLimit.endYear === null){
                    this.getPageData();
                }
            },
            async delConfirm(data){
                try {
                    await this.$confirm('是否确认删除?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                    let result = []
                    result.push(data)
                    await this.batchDel(result);
                } catch (e) {
                    this.$message({
                        type: 'info',
                        message: '删除失败'
                    });
                }
            },
            cancel(){
                this.$refs.addForm.resetFields();
              this.addDialog = false;
                this.addForm = {};
            },
            openEdit(data){
                this.status = 'edit'
                this.addDialog = true;
                this.addForm = JSON.parse(JSON.stringify(data));
            },
            openAdd(){
                this.status = 'add'
                this.addDialog = true;
                this.$set(this.addForm,'visible',true)
            },
            
            searchPage(){
              this.queryLimit.current = 1;
              this.getPageData();
            },
             async getPageData(){
                let result = await api.getList(this.queryLimit);
                this.tableData = result.data;
                for(let i of this.tableData.records){
                    if(i.visible == 1){
                        i.visible = true
                    }else{
                        i.visible = false
                    }
                }
            },
            addConfirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if (valid) {
                       this.addData();
                    } else {
                        return false;
                    }
                });
            },
            uploadConfirm(){
                this.uploadDialog = false;
            },
            async addData(){
                let result
                if(this.addForm.visible == true){
                    this.addForm.visible = 1
                }else{
                    this.addForm.visible = 0
                }
                if(this.status == 'add'){
                     result = await api.add(this.addForm);
                }else if(this.status == 'edit'){
                     result = await api.edit(this.addForm);
                }
                if(result.code == 200){
                    let msg =  this.status == "add" ? '添加成功': '编辑成功'
                    this.$message.success(msg);
                    this.addForm = {}
                    this.addDialog = false;
                    this.getPageData();
                }
            },
            async downloadModule(){
                let result = await api.downloadExcel();
                window.location.href = result.data.templateUrl;
            },
            async allExport(){
                let result = await api.fileExport();
                window.location.href = result.data.fileUrl;
            },
            async delTips(){
                if(!this.multipleSelection.length > 0){
                    this.$message({
                        message: "勾选需要删除的数据后才能批量删除哦",
                        type: "warning"
                    });
                }else if(this.multipleSelection.length > 0){
                    try {
                        await this.$confirm('是否确认删除?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        })
                        let result = []
                        this.multipleSelection.map(item =>{
                            result.push(item.id);
                        });
                        this.batchDel(result);
                    } catch (e) {
                        this.$message({
                            type: 'info',
                            message: '删除失败'
                        });
                    }

                }
            },
            async batchDel(data){
                let result = await api.delData(data);
                if(result.code == 200){
                    this.$message.success('删除成功!');
                    this.getPageData();
                }
            },
            beforeAvatarUploadImport(file) {
                let type = file.name.substr(file.name.lastIndexOf('.'))
                let flag = true
                if (type !== '.xlsx' && type !== '.xls') {
                    flag = false
                    this.$message.warning('上传格式错误')
                }
                return flag
            },
            fileUploadError(err, file) {
                this.$message.warning("文件上传失败！");
            },
            uploadConfig(file, callback) {
                this.importLoad = true;
                var formdata = new FormData()
                formdata.append('file', file.file);
                console.log(formdata)
                api.uploadFile(formdata).then((r) => {
                    this.importLoad = false;
                    if(r.code == 200){
                        this.$message.success('导入成功!');
                        this.getPageData();
                    }else{
                        this.getPageData();
                        window.location.href = r.data.errorFileUrl
                    }
                })
            },
        },
        mounted() {
            this.getPageData();
        }
    };
</script>

<style scoped lang="scss">
    .line {
        width: 100%;
        height: 1px;
        background: #eeeeee;
    }

    .wrap {
        width: calc(100% - 40px);
        padding: 0 20px;
        height: 100%;
        background: #f6f6f6;
        .title {
            height: 60px;
            line-height: 60px;
            .title_left {
                font-size: 20px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                width: 50%;
                height: 100%;
            }
        }
        .innerBox {
            width: calc(100% - 60px);
            padding: 20px 30px;
            height: calc(100% - 125px);
            background: #fff;
            border-radius: 10px;
            overflow: scroll;
            .filtrate {
                vertical-align: center;
                .year {
                    font-size: 12px;
                    line-height: 18px;
                    color: #666666;
                }
            }
            .operate {
                .left {
                    float: left;
                }
                .right {
                    float: right;
                }
            }
        }
        .module {
            background: #fff;
            width: 720px;
            height: 400px;
            margin: 0;
            padding: 0;
            .header {
                width: 100%;
                height: 60px;
                .left_header {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 358px;
                    height: 100%;
                    border-right: 1px solid #eeeeee;
                    box-sizing: border-box;
                }
                .right_header {
                    width: 358px;
                    height: 100%;
                    .title {
                        float: left;
                        font-size: 16px;
                        color: #333333;
                        line-height: 22px;
                        margin: 19px 0 0 30px;
                        display: inline-block;
                    }
                    .statistic {
                        font-size: 14px;
                        color: #999999;
                        line-height: 20px;
                        margin-top: 19px;
                        float: right;
                        display: inline-block;
                    }
                }
            }
            .textTip {
                text-align: center;
            }
            .left_module {
                width: 358px;
                height: 340px;
                display: inline-block;
                border-top: 1px solid #eeeeee;
                border-bottom: 1px solid #eeeeee;
                border-right: 1px solid #eeeeee;
                box-sizing: border-box;
                padding: 20px;
                overflow: scroll;
            }
            .right_module {
                width: 358px;
                height: 340px;
                display: inline-block;
                border-top: 1px solid #eeeeee;
                border-bottom: 1px solid #eeeeee;
                box-sizing: border-box;
                padding: 20px;
                overflow: scroll;
            }
        }
        .pagination-box {
            text-align: right;
            margin-top: 20px;
        }
    }
</style>